import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
      {categories.map((cat) => (
        <a
          key={cat.id}
          href={cat.url}
          target="_blank"
          rel="noopener nofollow"
          className="group flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden hover:border-primary-300 transition-all cursor-pointer"
          data-product-shop
        >
          <div className="w-full h-36 md:h-44 overflow-hidden">
            <img
              src={cat.image}
              alt={t(cat.nameKey)}
              title={`${t(cat.nameKey)} — usfans spreadsheet`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
          </div>
          <div className="flex items-center justify-between gap-2 px-4 py-3">
            <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
              {t(cat.nameKey)}
            </span>
            <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
          </div>
        </a>
      ))}
    </div>
  );
}